import { combineCheck } from '../quotes/offers/offers';

/**
 * „Oferta łączona” from the calendar (owner 2026-10-30): events picked with ⌘-click (Ctrl on other systems); when
 * they are of one client, „Połącz w ofertę” makes one offer of them; otherwise the bar says why it cannot.
 */

export const togglePicked = (list: readonly string[], id: string): string[] => (list.includes(id) ? list.filter((x) => x !== id) : [...list, id]);

export function PickedEventsBar({
  events,
  clientNames,
  clientHidden = false,
  mayCombine,
  busy = false,
  error = null,
  onCombine,
  onClear,
}: {
  events: ReadonlyArray<{ id: string; name?: string | undefined; contractorId?: string | null | undefined }>;
  clientNames: ReadonlyMap<string, string>;
  /** Review M6: the events' client field is hidden from the role (rule 7a): the one-client rule cannot be checked here. */
  clientHidden?: boolean;
  /** The right to make offers (quotes „create”). */
  mayCombine: boolean;
  busy?: boolean;
  error?: string | null;
  onCombine: (clientId: string, eventIds: string[]) => void;
  onClear: () => void;
}) {
  const check = clientHidden
    ? ({ ok: false, message: 'Nie możesz sprawdzić klienta tych wydarzeń — oferta łączona jest dla jednego klienta; połączy je ktoś, kto widzi klienta.' } as const)
    : combineCheck(
        events.map((e) => ({ name: e.name ?? '', contractorId: e.contractorId ?? null })),
        clientNames,
      );
  return (
    <p className="cal-picked-events" role="status" data-feature-id="quotes.offers">
      <span>
        Zaznaczone wydarzenia: <strong>{events.length}</strong>
      </span>
      {mayCombine && check.ok && (
        <button type="button" className="btn small primary" disabled={busy} onClick={() => onCombine(check.clientId, events.map((e) => e.id))}>
          Połącz w ofertę
        </button>
      )}
      {mayCombine && !check.ok && <span>{check.message}</span>}
      {error && <span className="field-error">{error}</span>}
      <button type="button" className="btn ghost small" onClick={onClear}>
        Wyczyść (Esc)
      </button>
    </p>
  );
}
